module.exports = __webpack_public_path__ + "img/fshrx3t.1c54e533.png";